/* eslint-disable no-param-reassign */
import Cookies from 'js-cookie';
import * as uuid from 'uuid/v4';
import mapSetters from 'vuex';
import {
  post,
  get
} from '../../API/cloudFunctions';
import firebase from 'firebase'

// this is module for the app states managements
function getList() {
  let dashboardWidgetsList = [];
  try {
    dashboardWidgetsList = JSON.parse(localStorage.getItem('dashboardWidgetsList'));
    if (!dashboardWidgetsList) {
      dashboardWidgetsList = [];
    }
  } catch (error) {
    dashboardWidgetsList = [];
  }
  return dashboardWidgetsList;
}

// the default widget list
function getDefaultList() {
  let dashboardWidgetsList = [{
    id: uuid(),
    widgetType: {
      name: 'mapWidget'
    },
    span: 16,
    title: 'Devices\' alerts Map',
    icon: 'icon-marker'
  },
    {
      id: uuid(),
      widgetType: {
        name: 'chartWidget',
        data: {
          type: 'pie-chart'
        }
      },
      span: 8,
      title: 'Alerts analytics',
      icon: 'icon-pie-chart'
    },
    {
      id: uuid(),
      widgetType: {
        name: 'chartWidget',
        data: {
          type: 'line-chart'
        }
      },
      span: 16,
      title: 'Statistics',
      icon: 'icon-analytics'
    },
    {
      id: uuid(),
      widgetType: {
        name: 'listWidget'
      },
      span: 8,
      title: 'Alert Messages',
      icon: 'icon-notification'
    }
  ];
  return dashboardWidgetsList;

}

/**
 * delete widhet by index
 * @param {*} widgetIndex
 * @version 1.0.0
 * @author amine.bouzahar
 * @copyright Tisalabs 2018
 */
function deleteWidget(widgetIndex) {
  return new Promise((resolve, reject) => {
    let dashboardWidgetsList = [];
    dashboardWidgetsList = JSON.parse(localStorage.getItem('dashboardWidgetsList'));
    console.log('DELETE CALLED BEFORE', dashboardWidgetsList, widgetIndex);
    if (widgetIndex !== -1 && dashboardWidgetsList) {
      dashboardWidgetsList = JSON.parse(localStorage.getItem('dashboardWidgetsList'));
      let widget = dashboardWidgetsList.findIndex(item => item.id === widgetIndex);
      console.log('widget being spliced', JSON.stringify(widget))
      dashboardWidgetsList.splice(widget, 1);
      console.log('DELETE CALLED After', dashboardWidgetsList, widgetIndex);
      let currentUser = JSON.parse(localStorage.getItem('currentUser'));
      localStorage.setItem('dashboardWidgetsList', JSON.stringify(dashboardWidgetsList));
              resolve(dashboardWidgetsList);

      // if (!currentUser) {
      //   post("getUser", {id: firebase.auth().currentUser.uid})
      //     .then(currentUserData => {
      //       currentUser = currentUserData;
      //       currentUser.dashboardWidgetsList = dashboardWidgetsList;
      //       post('updateUser', {
      //         updates: currentUser
      //       }).then(success => {
      //         localStorage.setItem('currentUser', JSON.stringify(currentUser));
      //         localStorage.setItem('dashboardWidgetsList', JSON.stringify(dashboardWidgetsList));
      //         resolve(dashboardWidgetsList);
      //       }).catch(err => {
      //         console.log(err);
      //
      //       });
      //     }).catch(err => {
      //     console.log(err);
      //
      //   });
      //
      // } else {
      //   currentUser.dashboardWidgetsList = dashboardWidgetsList;
      //
      //   post('updateUser', {
      //     updates: currentUser
      //   }).then(success => {
      //     localStorage.setItem('currentUser', JSON.stringify(currentUser));
      //     localStorage.setItem('dashboardWidgetsList', JSON.stringify(dashboardWidgetsList));
      //     resolve(dashboardWidgetsList);
      //   }).catch(err => {
      //     console.log(err);
      //   });
      // }

    }

  });

}

const dashboard = {
  state: {

    dashboardWidgetsList: getList(),

    list16: getList().filter(widget => widget.span === 16),
    list8: getList().filter(widget => widget.span === 8)

  },
  mutations: {

    /**
     *
     */
    SET_DEFAULT_DASHBOARD: (state, values) => {
      try {
        state.dashboardWidgetsList = getDefaultList();
        localStorage.setItem('dashboardWidgetsList', JSON.stringify(state.dashboardWidgetsList));
        state.list16 = state.dashboardWidgetsList.filter(widget => widget.span === 16);
        state.list8 = state.dashboardWidgetsList.filter(widget => widget.span === 8);
      } catch (e) {

      }
      return state.dashboardWidgetsList;
    },

    SET_DATSHBOARD: (state, values) => {
      if (values === []) {
        //setDefault components
        // values = [];
        this.dashboardWidgetsList = values;
        localStorage.setItem('dashboardWidgetsList', JSON.stringify(values));
      } else {
        this.dashboardWidgetsList = values;
        localStorage.setItem('dashboardWidgetsList', JSON.stringify(values));
      }
    },

    DELETE_WIDGET: (state, list) => {
      state.dashboardWidgetsList = list;
      state.list16 = getList().filter(widget => widget.span === 16);
      state.list8 = getList().filter(widget => widget.span === 8);
    },
    ADD_WIDGET: (state, widget) => {
      try {
        state.dashboardWidgetsList = JSON.parse(localStorage.getItem('dashboardWidgetsList')) || [];
        widget.id = uuid();
        state.dashboardWidgetsList.push(widget);
        localStorage.setItem('dashboardWidgetsList', JSON.stringify(state.dashboardWidgetsList));
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (!currentUser) {
          post("getUser", {id: firebase.auth().currentUser.uid})
            .then(currentUserData => {
              currentUser = currentUserData;
              currentUser.dashboardWidgetsList = dashboardWidgetsList;
              post('updateUser', {
                updates: currentUser
              }).then(success => {
                localStorage.setItem('currentUser', JSON.stringify(currentUser));
                localStorage.setItem('dashboardWidgetsList', JSON.stringify(dashboardWidgetsList));
                // resolve(dashboardWidgetsList);
                state.list16 = getList().filter(widget => widget.span === 16);
                state.list8 = getList().filter(widget => widget.span === 8);
              }).catch(err => {
                console.log(err);

              });
            }).catch(err => {
            console.log(err);

          });

        } else {
          currentUser.dashboardWidgetsList = dashboardWidgetsList;

          post('updateUser', {
            updates: currentUser
          }).then(success => {
            localStorage.setItem('currentUser', JSON.stringify(currentUser));
            localStorage.setItem('dashboardWidgetsList', JSON.stringify(dashboardWidgetsList));
            // resolve(dashboardWidgetsList);
            state.list16 = getList().filter(widget => widget.span === 16);
            state.list8 = getList().filter(widget => widget.span === 8);
          }).catch(err => {
            console.log(err);
          });
        }

      } catch (e) {

      }
      return state.dashboardWidgetsList;
    },
    UPDATE_DASHBOARD: (state, value) => {
      console.log('concat', value);
      state.dashboardWidgetsList = value
      localStorage.setItem('dashboardWidgetsList', JSON.stringify(state.dashboardWidgetsList));
      state.list16 = getList().filter(widget => widget.span === 16);
      state.list8 = getList().filter(widget => widget.span === 8);
    }

  },
  actions: {
    // ...mapSetters(["dashboardWidgetsList", "list8", "list16"]),
    set_default_dashboard({
                            commit
                          }) {
      commit('SET_DEFAULT_DASHBOARD')
    },
    setDashboard({
                   commit
                 }, values = []) {
      commit('SET_DATSHBOARD', values);
    },
    delete_widget({
                    commit
                  }, widgetIndex) {

      console.log('deleted widget index vuex=====>', widgetIndex)

      deleteWidget(widgetIndex).then(list => {
        console.log('vuex dashboard list', list)
        commit('DELETE_WIDGET', list);
      });


    },
    add_widget({
                 commit
               }, widget) {
      commit('ADD_WIDGET', widget)
    },
    get_dashboardWidgetsList({
                               commit
                             }) {
      commit('GET_WIDGETS')

    },
    update_dashboard({
                       commit
                     }, arr) {
      //console.log(listsmall, listlarge)
      commit('UPDATE_DASHBOARD', arr);
    }
  }
}

export default dashboard



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js